<button type="button" class="re-bold hover:re-text-secondary-hover" (click)="onClickButton()">
  <div class="re-flex re-flex-row re-items-center">
    @if (iconStyle === 'plus') {
      <svg-icon src="assets/icons/plus_circle.svg"></svg-icon>
    }
    @if (iconStyle === 'minus') {
      <svg-icon src="assets/icons/minus_circle.svg"></svg-icon>
    }

    <span class="bold re-ml-20 re-text-left re-text-secondary
                 md:re-text-center md:re-mt-0">
      {{ label }}
    </span>
  </div>
</button>
